import React from "react";
import t from "../../../../../i18n";
import Modal from "@ui/Modal";
import { useModals } from "@ui/lib/hooks/useModal";
import { ImportFailuresModalForm } from "./Failures/ImportModalForm";
import { DeleteFailuresModalForm } from "./Failures/DeleteModalForm";
import type { FailuresModal } from "./Failures/Table";
import FailuresTable from "./Failures/Table";
import Card from "@ui/Card";
import type { Failure, Setup } from "../../../../../api/useSetups";
import { useCanUserDoOnProject } from "../../../../canUserDo";
import BlankStateV2 from "@ui/BlankStateV2";
import { styled } from "@linaria/react";
import type { Project } from "../../../../../api/useProjects";

const StyledBlankStateV2 = styled(BlankStateV2)`
  padding: 25px 20px;
`;

export const FailuresInfo = ({
  project,
  failures,
  setup,
  setups,
}: {
  project: Project;
  failures: Failure[];
  setup: Setup;
  setups: Setup[];
}) => {
  const { modal, closeModal, openModal } = useModals<FailuresModal>();
  const canEditSetup = useCanUserDoOnProject("PROJECT_SETUP", project.id);

  const hasFailures = failures.length > 0;
  const [editedDataKey, setEditedDataKey] = React.useState<string>();

  return (
    <>
      {hasFailures ? (
        <FailuresTable
          failures={failures}
          project={project}
          openModal={openModal}
          setup={setup}
          setups={setups}
          editedDataKey={editedDataKey}
          setEditedDataKey={setEditedDataKey}
          editable
        />
      ) : (
        <Card>
          <StyledBlankStateV2
            title={t("setup.diagnosis.failure.blank.title")}
            subtitle={canEditSetup ? t("setup.diagnosis.failure.blank.subtitle") : null}
            onClick={canEditSetup ? () => openModal("failuresImport") : undefined}
            buttonLabel={canEditSetup ? t("setup.diagnosis.failure.blank.button") : undefined}
          />
        </Card>
      )}
      <Modal
        isOpen={modal === "failuresImport"}
        onRequestClose={closeModal}
        title={t("setup.paragraphs.failures.modal.import_failures")}
      >
        <ImportFailuresModalForm
          onRequestClose={closeModal}
          onSetEditedDataKey={setEditedDataKey}
          project={project}
          setup={setup}
          setups={setups}
        />
      </Modal>
      <Modal
        isOpen={modal === "failuresDelete"}
        onRequestClose={closeModal}
        title={t("setup.diagnosis.failures.delete_observables.title")}
      >
        <DeleteFailuresModalForm onRequestClose={closeModal} project={project} setup={setup} />
      </Modal>
    </>
  );
};
